import { Anulicense } from "../license"

const ReleationBanner = () =>{
    return(
        <section className="bg-primary text-white py-16 px-6">
            <div className="container mx-auto">
                <div>
                    <div className="flex">
                        <div className=" hidden lg:block xl:block">
                            <img src={Anulicense.groupImage_2} className="w-[500px]" alt="img"/>
                            <img src={Anulicense.groupImage} className="w-[500px]" alt="img"/>
                        </div>
                        <div className="block justify-start mb-20 ">
                            <div className="w-full z-10 relative">
                                <h4 className="lg:text-[24px] xl:text-[24px] md:text-[24px] xl:leading-[60px] lg:leading-[60px] md:leading-[60px] text-[18px] leading-[30px] font-secondary_font font-bold text-[#aa8210]">
                                    Needs Any Helps
                                </h4>
                                <h2 className="lg:text-[50px] xl:text-[50px] md:text-[50px] text-[28px] xl:leading-[60px] lg:leading-[60px] md:leading-[60px] leading-[35px] font-medium">
                                    Always Ready To Print Your Dream Works
                                </h2>
                                <span className="font-secondary_font lg:text-[150px] xl:text-[150px] md:text-[150px] text-[90px] shadow-text-left">
                                    Unique Designs
                                </span>
                            </div>
                            <div>
                                <p className="border-l-4 border-yellow-400 pl-4 text-lg mb-10">
                                    We strive to achieve the best possible customer service through friendly,
                                    fast service and attention to detail.
                                </p>
                                <ul className="space-y-6 text-base sm:text-lg">
                                    <li className="flex items-start gap-3">
                                        <span className="text-yellow-400 text-xl">✔</span>
                                        <span>
                                        <strong>Quality Printing:</strong> Bright inks. Thick Paper. Precise
                                        cuts. We believe that quality printing matters. That quality printing
                                        matters.
                                        </span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <span className="text-yellow-400 text-xl">✔</span>
                                        <span>
                                        <strong>Timely Delivery:</strong> a unique team of professionals
                                        dedicated to providing the utmost in time definite service.
                                        </span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <span className="text-yellow-400 text-xl">✔</span>
                                        <span>24x7 Customer Support</span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <span className="text-yellow-400 text-xl">✔</span>
                                        <span>Unique Designs</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ReleationBanner